import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchVorlagen(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('buchhaltung_vorlagen')
    .select('id, name, beschreibung, firmenname, updated_at')
    .or(`name.ilike.${pattern},beschreibung.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Vorlagen search error:', error);
    return [];
  }

  return (data || [])
    .filter(v => matchFn(term, v.name, v.beschreibung, v.firmenname))
    .slice(0, limit)
    .map(v => {
      const title = v.name || 'Vorlage';
      const subtitle = v.beschreibung || v.firmenname || undefined;
      
      return {
        id: v.id,
        type: 'vorlagen' as SearchSectionId,
        title,
        subtitle,
        badge: 'Vorlage',
        data: v,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, v.updated_at)
      };
    });
}
